module.exports = __webpack_public_path__ + "img/rentcar_en.fd74273a.png";